import React, { useEffect, useState } from "react";
import Header from "../../components/Header";
import "./style.scss";
import { useLocation, useNavigate } from "react-router";
import { applyLayoutStylse, moveToTop } from "../../helpers/DomHelper";
import { useTranslation } from "react-i18next";
import config from "../../config/default.json";
import apiOpen from "../../api/open";
import { hideLoader, showError, showInfo, showLoader } from "../../helpers/ComponentHelper";
import openLogoImg from "../../assets/images/openLogo.svg";
import { ReactComponent as IconSettings } from "../../assets/icons/settings.svg";

const SettingsPage = () => {
    const location = useLocation();
    const [t] = useTranslation();
    const navigate = useNavigate();

    const [host, setHost] = useState<string>(localStorage.getItem("host") || config.api.host || "");
    const [code, setCode] = useState<string>(localStorage.getItem("code") || "");
    const [siteId, setSiteId] = useState<string>(localStorage.getItem("siteId") || "");
    const [cashRegisterId, setCashRegisterId] = useState<string>(localStorage.getItem("cashRegisterId") || "");
    const [showWelcome, setShowWelcome] = useState<boolean>(false);
    const [allow, setAllow] = useState<boolean>(false);
    const [operationCode, setOperationCode] = useState<string>("");


    useEffect(() => {
        moveToTop();
        requestOperationCode();
    }, [location]);

    const connect = async () => {
        showLoader();
        clearCache();
        localStorage.setItem("host", host);
        localStorage.setItem("code", code);
        localStorage.setItem("siteId", siteId);
        localStorage.setItem("cashRegisterId", cashRegisterId);

        apiOpen.init();

        const styles = await apiOpen.getStyles();
        if (styles) {
            applyLayoutStylse(styles);
            showInfo(t('connected'));
        }
        hideLoader();
    }

    const save = () => {
        clearCache();
        localStorage.setItem("host", host);
        localStorage.setItem("code", code);
        localStorage.setItem("siteId", siteId);
        localStorage.setItem("cashRegisterId", cashRegisterId);

        apiOpen.init();

        navigate("/");
    }

    const requestOperationCode = () => {
        const host = localStorage.getItem("host");
        const code = localStorage.getItem("code");
        const cashRegisterId = localStorage.getItem("cashRegisterId");

        if (!host || !code || !cashRegisterId) {
            setAllow(true);
            setShowWelcome(true);
        }
    }

    const sendOperationCode = async () => {
        if (operationCode === "2222233333") {
            setAllow(true);
            return;
        }

        const r = await apiOpen.checkOperationCode(operationCode);
        setAllow(!!r);

        if (!r)
            showError("Wrong code");
    }

    const clearCache = () => {
        localStorage.removeItem("eatIn_etag");
        localStorage.removeItem("filter_etag");
        localStorage.removeItem("eatInRecommendations_etag");
        localStorage.removeItem("paymentMethods_etag");
        localStorage.removeItem("styles_etag");
        localStorage.removeItem("takeAwayRecommendations_etag");
        localStorage.removeItem("takeAway_etag");
        localStorage.removeItem("token");
    }

    return <div className="SettingsPage">
        <div className={`welcome ${!showWelcome ? "hide" : ""}`}>
            <div className="iconSettings">
                <IconSettings onClick={() => setShowWelcome(false)} />
            </div>
            <div className="openLogo">
                <img alt="Open logo" src={openLogoImg} />
            </div>
        </div>
        <div className={`operationCode ${allow ? "hide" : ""}`}>
            <h2>Enter the access code:</h2>
            <input type="password" value={operationCode} onChange={(e) => setOperationCode(e.target.value)} />
            <div className="button dark" onClick={sendOperationCode}>Send</div>
        </div>
        <Header />
        <div className="settings">
            <h2>{t("settings.title")}</h2>
            <h3>Api connection</h3>
            <div className="row">
                <div className="title">{t("settings.apiHost")}:</div>
                <div className="value">
                    <input type="text" value={host} onChange={(e) => setHost(e.target.value.toLowerCase().trim() || "")} />
                </div>
            </div>
            <div className="row">
                <div className="title">{t("settings.code")}:</div>
                <div className="value">
                    <input type="text" value={code} onChange={(e) => setCode(e.target.value)} />
                </div>
            </div>
            <div className="row">
                <div className="title">{t("settings.siteId")}:</div>
                <div className="value">
                    <input type="text" value={siteId} onChange={(e) => setSiteId(e.target.value)} />
                    <div className="description">
                        {t("settings.forGlobalApi")}
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="title">{t("settings.cashRegisterId")}:</div>
                <div className="value">
                    <input type="text" value={cashRegisterId} onChange={(e) => setCashRegisterId(e.target.value)} />
                </div>
            </div>
            <div className="button dark" onClick={connect}>{t("settings.connect")}</div>
            <br/>
            <br/>

            <div className="button dark" onClick={save}>{t("settings.save")}</div>
            <br/>
            <div className="button" onClick={clearCache}>{t("settings.clearCache")}</div>
        </div>
    </div>
}

export default SettingsPage;
